import React from "react";
import "./tarifs.css";

import Template from "../../components/template/Template";

import TarifsFormula from "./tarifsComponents/tarifsFormula";
import TarifsDetails from "./tarifsComponents/tarifsDetails";

import MainBackground from "../../components/template/MainBackground";

import { useRef } from "react";
import TarifsMap from "./tarifsComponents/tarifsMap";

import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import TarifsResponsivSelector from "./tarifsComponents/tarifsResponsivSelector";

function Tarifs() {
  const tarifsDetailsRef = useRef(null);
  const tarifsDetailsScroll = () => {
    if (tarifsDetailsRef.current) {
      tarifsDetailsRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };
  const tarifsMapRef = useRef(null);
  const tarifsMapScroll = () => {
    if (tarifsMapRef.current) {
      tarifsMapRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const location = useLocation();
  useEffect(() => {
    if (location.hash === "#tarifs-details" && tarifsDetailsRef.current) {
      tarifsDetailsRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [location]);

  return (
    <Template>
      <div className="tarifs-main">
        <div className="tarifs-part-A-contenair">
          <MainBackground>
            <div className="tarifs-part-A">
              <TarifsFormula
                scrollToDetails={tarifsDetailsScroll}
                scrollToMap={tarifsMapScroll}
              />
            </div>
          </MainBackground>
        </div>
        <div ref={tarifsDetailsRef} className="tarifs-part-B">
          <TarifsResponsivSelector />
          <div className="tarifs-shadow-effect"></div>
        </div>
        <div ref={tarifsMapRef} className="tarifs-part-C">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              paddingTop: "20px",
              paddingBottom: "40px",
            }}
          >
            <div className="map-title">TARIFS DES DEPLACEMENTS</div>
          </div>
          <div className="map-list-container">
            <TarifsMap
              cost="10€"
              postalCodes={[
                "Toulouse Intra Périphérique",
                "+ Campus Paul Sabatier",
              ]}
            />

            <TarifsMap
              cost="20€"
              postalCodes={[
                "Toulouse Extra Périphérique",
                "Cugnaux",
                "Tournefeuille",
                "Colomiers",
                "Blagnac",
                "Portet-sur-Garonne",
              ]}
            />
            <TarifsMap
              cost="30€"
              postalCodes={[
                "Aucamville",
                "Aussonne",
                "Auzeville-Tolosane",
                "Balma",
                "Castanet-Tolosan",
                "Castelginest",
                "Cornebarieu",
                "Fenouillet",
                "Flourens",
                "Fonbeauzard",
                "Frouzins",
                "Gagnac-sur-Garonne",
                "L'Union",
                "La Salvetat-Saint-Gilles",
                "Labege",
                "Lacroix-Falgarde",
                "Launaguet",
                "Lespinasse",
                "Mervilla",
                "Montrabé",
                "Pin-Balma",
                "Pin-Justaret",
                "Pinsaguel",
                "Plaisance-du-Touch",
                "Péchabou",
                "Quint-Fonsegrives",
                "Rebigue",
                "Roquettes",
                "Saint-Geniès-Bellevue",
                "Saint-Jean",
                "Saint-Loup-Cammas",
                "Saint-Orens-de-Gameville",
                "Saubens",
                "Seilh",
                "Seysses",
              ]}
            />
          </div>
        </div>
      </div>
    </Template>
  );
}

export default Tarifs;
